export default __webpack_public_path__ + "static/media/slackIcon.3b617a8a.svg";